"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.BrowserType = void 0;
exports.getBrowserInfo = getBrowserInfo;
exports.getHiddenProperty = getHiddenProperty;
exports.getVisibilityEvent = getVisibilityEvent;

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/parse-int"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/includes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var browserInfo;
var BrowserType;
exports.BrowserType = BrowserType;

(function (BrowserType) {
  BrowserType["IE"] = "IE";
  BrowserType["Edge"] = "Edge";
  BrowserType["Firefox"] = "Firefox";
  BrowserType["Opera"] = "Opera";
  BrowserType["Safari"] = "Safari";
  BrowserType["Chrome"] = "Chrome";
  BrowserType["Unknown"] = "Unknown";
})(BrowserType || (exports.BrowserType = BrowserType = {}));

function getBrowserInfo() {
  if (browserInfo) {
    return browserInfo;
  }

  var type;
  var match;
  var userAgent = navigator.userAgent;

  if ((0, _includes.default)(userAgent).call(userAgent, 'Opera')) {
    type = BrowserType.Opera;
    match = userAgent.match(/Opera.([\d.]+)/);
  } else if ((0, _includes.default)(userAgent).call(userAgent, 'MSIE') || (0, _includes.default)(userAgent).call(userAgent, 'Trident')) {
    type = BrowserType.IE;
    match = userAgent.match(/MSIE ([\d.]+)/) || userAgent.match(/rv:([\d.]+)/);
  } else if ((0, _includes.default)(userAgent).call(userAgent, 'Edge')) {
    type = BrowserType.Edge;
    match = userAgent.match(/Edge\/([\d.]+)/);
  } else if ((0, _includes.default)(userAgent).call(userAgent, 'Firefox')) {
    type = BrowserType.Firefox;
    match = userAgent.match(/Firefox\/([\d.]+)/);
  } else if ((0, _includes.default)(userAgent).call(userAgent, 'Safari') && !(0, _includes.default)(userAgent).call(userAgent, 'Chrome')) {
    type = BrowserType.Safari;
    match = userAgent.match(/Version\/([\d.]+)/);
  } else if ((0, _includes.default)(userAgent).call(userAgent, 'Chrome') && (0, _includes.default)(userAgent).call(userAgent, 'Safari')) {
    type = BrowserType.Chrome;
    match = userAgent.match(/Chrome\/([\d.]+)/);
  } else {
    type = BrowserType.Unknown;
    match = null;
  }

  browserInfo = {
    type: type,
    version: match ? (0, _parseInt2.default)(match[1]) : -1
  };
  return browserInfo;
} // Get Browser-Specific Prefix
// 以 hidden 属性来作为判断浏览器前缀的依据


function getBrowserPrefix() {
  // check hidden
  if ('hidden' in document) {
    return null;
  } // All the possible prefixes


  var browserPrefixes = ['moz', 'ms', 'o', 'webkit'];

  for (var i = 0; i < browserPrefixes.length; i += 1) {
    var prefix = "".concat(browserPrefixes[i], "Hidden");

    if (prefix in document) {
      return browserPrefixes[i];
    }
  } // The API is not supported in browser


  return null;
} // Get Browser Specific Hidden Property


function getHiddenProperty() {
  var prefix = getBrowserPrefix();

  if (prefix) {
    return "".concat(prefix, "Hidden");
  }

  return 'hidden';
} // Get Browser Specific Event


function getVisibilityEvent() {
  var prefix = getBrowserPrefix();

  if (prefix) {
    return "".concat(prefix, "visibilitychange");
  }

  return 'visibilitychange';
}